module.exports = __webpack_public_path__ + "img/電気回路_3_6_5.a8c2410b.png";